import {Box, Flex, Image, Space, Text} from "@mantine/core";
import {Carousel} from "@mantine/carousel";
import { useRef } from '@wordpress/element';
import Autoplay from 'embla-carousel-autoplay';
import CategoryPlaceholderImage from '../../../../../assets/images/category_placeholder.png';
const _Collections = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                fz="18px"
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                bg={component?.customize_styles?.text_decoration?.background_color}
                lh='1'
                fw={700}
            >
                {component?.customize_properties?.label}
            </Text>
            <Space h="lg"/>
            <Carousel
                loop
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}
                slideSize={70}
                slideGap={component?.customize_styles?.box_decoration?.margin_x}
                align="start"
                withControls={false}
                styles={{
                    viewport: {
                        overflow: "visible",
                        overflowX: "clip",
                    },
                }}
            >

                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide key={index}>
                            <Flex
                                p={10}
                                w={250}
                                align="center"
                                gap={15}

                                // mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}

                                bg={component?.customize_styles?.box_decoration?.background_color}
                                style={{
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    display: "flex",
                                    alignItems: "flex-end",
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                }}

                            >
                                <Image
                                    src={item?.image_url}
                                    fallbackSrc={CategoryPlaceholderImage}
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    alt=""
                                    radius={component?.customize_styles?.image_decoration?.radius}
                                    w={50}
                                />
                                <Box>
                                    <Text
                                        lineClamp={1}
                                        translate="yes"
                                        c={component?.customize_styles?.name_text_decoration?.color}
                                        fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                        fz={component?.customize_styles?.name_text_decoration?.font_size}
                                        fs={component?.customize_styles?.name_text_decoration?.font_style}
                                    >
                                        {item?.name}
                                    </Text>
                                    <Text mt={4} fz={13} c="#868E96">
                                        {item?.item_count} items
                                    </Text>
                                </Box>
                            </Flex>
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
        </Box>
    )
}
export default _Collections;